import React from 'react'

import styles from './SpFooter.module.css'

type Props = {
  onBack: () => void
  onNext: () => void
  isNextDisabled?: boolean
  backDgId?: string
  nextDgId?: string
  backLabel?: string
  nextLabel?: string
}

// SP フローの「もどる / 次へ」フッター（総合受付ローカル共通・EntryLoad / EntryConfirmation でも再利用）
// NOTE: レガシー Reception/components/SpFooter を写経（cross-container import はしない / requirements.md L53）
export const SpFooter = ({
  onBack,
  onNext,
  isNextDisabled = false,
  backDgId,
  nextDgId,
  backLabel = 'もどる',
  nextLabel = '次へ',
}: Props) => (
  <div className={styles.footer}>
    <button
      type="button"
      className={`${styles.button} ${styles.backButton}`}
      onClick={onBack}
      data-dg-id={backDgId}
    >
      {backLabel}
    </button>
    <button
      type="button"
      className={`${styles.button} ${styles.nextButton}`}
      disabled={isNextDisabled}
      onClick={onNext}
      data-dg-id={nextDgId}
    >
      {nextLabel}
    </button>
  </div>
)
